import { CSSProperties, MutableRefObject, ReactNode } from 'react';
// 常量
import { ColumnType, } from 'antd/lib/table';
import { SimpleFormItemProps } from '../SimpleForm';
import { FormInstance } from 'antd/lib/form';

export const MAIN_FORM_KEY = 'main';
export const CHILDREN_DATA_KEY: string = 'children';
export const CHILDREN_COLUMNS_KEY: string = 'children_columns';
export const MAIN_ROW_KEY = 'isMainTable';
export const ALL_CHILDREN_KEY: string = 'allChildren';

interface EditDynamicSubTableAction {
  /** 提交 */
  submit: () => Promise<any[] | false>;
  /** 清空数据 */
  empty: () => void;
  /**
   * 获取数据
   * @param filterDeleteData 是否过滤已删除数据
   * @returns 
   */
  getDataSource: (filterDeleteData?: boolean) => any[];
}

export type EditDynamicSubTableActionType = EditDynamicSubTableAction | undefined;

// change类型
export type onValuesChange = (
  name: any,
  value: any,
  mainKey: any,
  childrenKey: any,
  form: FormInstance,
  record: any,
) => void;

export interface EditDynamicSubTableProps {
  /** 类名 */
  className?: string;
  /** 样式 */
  style?: CSSProperties;
  /** 数据数组 */
  dataSource?: any[];
  /** 主表列配置 */
  mainColumns?: EditDynamicSubTableColumnType[];
  /** 是否展开所有行 */
  defaultExpandAllRows?: boolean;
  /** 对外提供方法 */
  actionRef?: MutableRefObject<EditDynamicSubTableActionType>;
  /** 支持虚拟列表 */
  virtual?: boolean;
  /** 字段值更新时触发回调事件 */
  onValuesChange?: onValuesChange;
};

export type EditDynamicSubTableFormItemType = 'Input' | 'InputNumber' | 'SuperSelectTable';

/** 列配置属性 */
export interface EditDynamicSubTableColumnType extends ColumnType<any>, Omit<SimpleFormItemProps, 'disabledRender'> {
  /** 是否可编辑 */
  editable?: boolean;
  /** 是否禁用表单 */
  disabled?: boolean | ((record: any) => boolean);
  /** 禁用时用哪个字段显示 */
  disabledRender?: ReactNode | ((record: any) => ReactNode);
  /** 表单类型 */
  formItemType?: EditDynamicSubTableFormItemType;
  /** 第几行 */
  rowIndex?: number;
  /** form表单对象 */
  form?: FormInstance;
  /** 表单字段名 */
  name?: any[];
}

/** 主表行配置属性 */
export interface MainTableCellProps {
  /** 是否可编辑 */
  editable?: boolean;
  /** 当前行数据 */
  record?: any;
  /** 第几行 */
  rowIndex?: number;
  /** 表单类型 */
  formItemType?: EditDynamicSubTableFormItemType;
  /** 表单props */
  simpleFormItemProps?: SimpleFormItemProps;
  /** form表单对象 */
  form?: FormInstance;
  /** 单元格数据字段 */
  name?: string | string[];
};

/** 子表表格配置 */
export interface EditSubTableProps {
  /** 数据数组 */
  dataSource?: any[];
  /** 主表列配置 */
  childrenColumns?: EditDynamicSubTableColumnType[];
  /** 主表key */
  mainKey?: string;
}

/** 子表行配置属性 */
export interface ChildrenTableCellProps extends MainTableCellProps {
  
}
